module.exports = __webpack_public_path__ + "micronesia.svg?1170f0fbd6a78c6ed917e7fffe5553e3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/micronesia.svg
// module id = 232
// module chunks = 10